export default "__VITE_ASSET__DnhIVZMS__"